import React from 'react';
import PropTypes from 'prop-types'; 

function ProfKat(props) {
    return (
        <div>
              {/* Instructor profile */}
              <div className="col-xl-12 col-lg-12">
              <div className="settings-widget card-details mb-0">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>{props.header?.nm_kategory}</h3>
                  </div>
                  <div className="checkout-form personal-address">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="contact-info">
                          <h6>Jumlah Jenis Pangan</h6>
                          <p>{props.countkat} Jenis Pangan</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="contact-info">
                          <h6>Jumlah Parameter Uji</h6>
                          <p>{props.countpar} Parameter Uji</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="contact-info">
                          <h6>Jenis Pengujian</h6>
                          <p>  <span className="web-badge">Pengujian Kimia</span>&nbsp;
                          <span className="web-badge">Pengujian Mikrobiologi</span>&nbsp;</p>
                        </div>
                      </div>
                 
                      <div className="col-sm-12">
                        <div className="contact-info mb-0">
                          <h6>Deskripsi</h6>
                          <p>
                            {" "}
                            {
                             props.header?.descript ? props.header.descript : '-'
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            {/* /Instructor profile */}
        </div>
    );
}
ProfKat.propTypes = {
  header: PropTypes.object, // objek kategori dari API; null bila tidak ditemukan
  countkat: PropTypes.number.isRequired, // Define title as required string
  countpar: PropTypes.number.isRequired, // Define title as required string
};

export default ProfKat;